import React, { useState } from "react";
import { unpairHeadset } from "../helpers/requests";
import "../../styles/admin.css";
import { useTranslation } from "react-i18next";

const ConfirmUnpairHeadsetModal = ({
  setShowConfirmUnpairHeadsetModal,
  licenseId,
  headsetName,
  handleUnpairHeadsetSubmit,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleUnpairClick = async () => {
    if (!licenseId) return;
    setIsLoading(true);
    try {
      await unpairHeadset(licenseId);
      setShowConfirmUnpairHeadsetModal(false);
      handleUnpairHeadsetSubmit();
    } catch (error) {
      console.error("Error unpairing headset:", error);
      alert(t("Failed_to_unpair_headset") || "Failed to unpair headset");
      setIsLoading(false);
    }
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div
          style={{ textAlign: "center", fontSize: "1.3em", marginTop: "2vh" }}
        >
          {t("Confirm_to_unpair_headset")}
        </div>
        <label style={{ lineHeight: "1.5", marginTop: "2vh", textAlign: "center" }}>
          {t("The_headset_will_be_unpaired_from_this_license_and_plans_deleted")}
        </label>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5vh",
            maxHeight: "1%",
          }}
        >
          <div className="userDataWrapper">
            {headsetName}
          </div>
        </div>

        <div className="button-container">
          <button
            type="button"
            className="buttonCancel btn btn-primary"
            disabled={isLoading}
            onClick={() => setShowConfirmUnpairHeadsetModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="buttonAccept btn btn-primary"
            disabled={isLoading}
            onClick={handleUnpairClick}
          >
            {isLoading ? t("Loading...") : t("Unpair")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmUnpairHeadsetModal;
